import Axios, { AxiosResponse, AxiosInstance } from 'axios'

class Config {
  private config: any = {}
  private envConfig: any = {}
  private localConfig: any = {}
  private remoteConfig: any = {}

  private $http: AxiosInstance

  constructor() {
    this.$http = Axios.create()
  }

  getConfig(): Promise<any> {
    return this.getEnvConfig()
      .then(response => {
        return this.setEnvConfig(response)
      })
      .then(() => {
        return this.getLocalConfig()
      })
      .then(response => {
        return this.setLocalConfig(response)
      })
      .then(response => {
        let endpoint = this.config.endpoint ? this.config.endpoint : 'http://localhost:8080'
        return this.getRemoteConfig(endpoint)
      })
      .then(response => {
        return this.setRemoteConfig(response)
      })
      .catch((error: any) => {
        console.log(error)
        throw(error)
      })
  }

  getEnvConfig() {
    return new Promise((resolve, reject) => {
      let envConfig = {}
      // @ts-ignore 
      if (window.configuration.ALERTA_ENDPOINT) {
        // @ts-ignore
        envConfig['endpoint'] = window.configuration.ALERTA_ENDPOINT
      }
      // @ts-ignore
      if (window.configuration.CLIENT_ID) {
        // @ts-ignore
        envConfig['client_id'] = window.configuration.CLIENT_ID
      }
      // @ts-ignore
      if (window.configuration.TRACKING_ID) {
        // @ts-ignore
        envConfig['tracking_id'] = window.configuration.TRACKING_ID
      }
      // @ts-ignore
      if (window.configuration.DEPLOYMENT_API_URL) {
        // @ts-ignore
        envConfig['deployment_api_url'] = window.configuration.DEPLOYMENT_API_URL
      }
      resolve(envConfig)
    })
  }

  getLocalConfig() {
    const basePath = process.env.BASE_URL
    return this.$http
      .get(`${basePath}config.json`)
      .then(response => response.data)
      .catch((error: any) => {
        console.warn(error.message)
      })
  }

  getRemoteConfig(endpoint: string) {
    return this.$http
      .get(`${endpoint}/config`)
      .then(response => response.data)
      .catch((error: any) => {
        alert(
          'ERROR: Failed to connect to Alerta API due to missing or invalid ' +
          'config.json file.\n\n' +
          'Please confirm a config.json file exists, contains an "endpoint" ' +
          'setting and is in the same directory as the application index.html ' +
          'file.'
        )
        throw(error)
      })
  }

  mergeConfig() {
    return (this.config = { ...this.remoteConfig, ...this.localConfig, ...this.envConfig })
  }

  setEnvConfig(data: any) {
    this.envConfig = data
    return this.mergeConfig()
  }

  setLocalConfig(data: any) {
    this.localConfig = data
    return this.mergeConfig()
  }

  setRemoteConfig(data: any) {
    this.remoteConfig = data
    return this.mergeConfig()
  }

  $get() {
    return this.config
  }
}

export default new Config()
